import React from 'react';

import { FormControlGroupProvider } from '../../providers/form-control-group-provider';
import { FormControlGroupWrapper } from './form-control-group-wrapper';
import { FormControlGroupProps } from './types';

export const FormControlGroup = ({
  children,
  ...props
}: FormControlGroupProps) => {
  return (
    <FormControlGroupProvider>
      <FormControlGroupWrapper {...props}>{children}</FormControlGroupWrapper>
    </FormControlGroupProvider>
  );
};
